"use strict";

var _classCallCheck = require("/home/cleysonph/playground/TypeScript-Website/node_modules/gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/cleysonph/playground/TypeScript-Website/node_modules/gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OnigString = /*#__PURE__*/function () {
  function OnigString(content) {
    var _this = this;

    _classCallCheck(this, OnigString);

    this.substring = function (start, end) {
      return _this.source.substring(start, end);
    };

    this.toString = function (start, end) {
      return _this.source;
    };

    if (typeof content !== 'string') {
      throw new TypeError('Argument must be a string');
    }

    this.source = content;
    this._utf8Bytes = null;
    this._utf8Indexes = null;
  }

  _createClass(OnigString, [{
    key: "utf8Bytes",
    get: function get() {
      if (!this._utf8Bytes) {
        this.encode();
      }

      return this._utf8Bytes;
    }
    /**
     * Returns `null` if all utf8 offsets match utf-16 offset (content has no multi byte characters)
     */

  }, {
    key: "utf8Indexes",
    get: function get() {
      if (!this._utf8Bytes) {
        this.encode();
      }

      return this._utf8Indexes;
    }
  }, {
    key: "content",
    get: function get() {
      return this.source;
    }
  }, {
    key: "length",
    get: function get() {
      return this.source.length;
    }
  }, {
    key: "hasMultiByteCharacters",
    get: function get() {
      return this.utf8Indexes !== null;
    }
  }, {
    key: "convertUtf8OffsetToUtf16",
    value: function convertUtf8OffsetToUtf16(utf8Offset) {
      if (utf8Offset < 0) {
        return 0;
      }

      var utf8Array = this._utf8Bytes;

      if (utf8Offset >= utf8Array.length - 1) {
        return this.source.length;
      }

      var utf8OffsetMap = this.utf8Indexes;

      if (utf8OffsetMap && utf8Offset >= this._mappingTableStartOffset) {
        return findFirstInSorted(utf8OffsetMap, utf8Offset - this._mappingTableStartOffset) + this._mappingTableStartOffset;
      }

      return utf8Offset;
    }
  }, {
    key: "convertUtf16OffsetToUtf8",
    value: function convertUtf16OffsetToUtf8(utf16Offset) {
      if (utf16Offset < 0) {
        return 0;
      }

      var utf8Array = this._utf8Bytes;

      if (utf16Offset >= this.source.length) {
        return utf8Array.length - 1;
      }

      var utf8OffsetMap = this.utf8Indexes;

      if (utf8OffsetMap && utf16Offset >= this._mappingTableStartOffset) {
        return utf8OffsetMap[utf16Offset - this._mappingTableStartOffset] + this._mappingTableStartOffset;
      }

      return utf16Offset;
    }
  }, {
    key: "encode",
    value: function encode() {
      var str = this.source;
      var n = str.length;
      var utf16OffsetToUtf8;
      var utf8Offset = 0;
      var mappingTableStartOffset = 0;

      function createOffsetTable(startOffset) {
        var maxUtf8Len = (n - startOffset) * 3;

        if (maxUtf8Len <= 0xff) {
          utf16OffsetToUtf8 = new Uint8Array(n - startOffset);
        } else if (maxUtf8Len <= 0xffff) {
          utf16OffsetToUtf8 = new Uint16Array(n - startOffset);
        } else {
          utf16OffsetToUtf8 = new Uint32Array(n - startOffset);
        }

        mappingTableStartOffset = startOffset;
        utf16OffsetToUtf8[utf8Offset++] = 0;
      }

      var u8view = new Uint8Array(n * 3 +
      /* alloc max now, trim later*/
      1
      /** null termination character */
      );
      var ptrHead = 0;
      var i = 0; // for some reason, v8 is faster with str.length than using a variable (might be illusion)

      while (i < str.length) {
        var codepoint = void 0;
        var c = str.charCodeAt(i);

        if (utf16OffsetToUtf8) {
          utf16OffsetToUtf8[utf8Offset++] = ptrHead - mappingTableStartOffset;
        }

        if (c < 0xD800 || c > 0xDFFF) {
          codepoint = c;
        } else if (c >= 0xDC00) {
          codepoint = 0xFFFD;
        } else {
          if (i === n - 1) {
            codepoint = 0xFFFD;
          } else {
            var d = str.charCodeAt(i + 1);

            if (0xDC00 <= d && d <= 0xDFFF) {
              if (!utf16OffsetToUtf8) {
                createOffsetTable(i);
              }

              var a = c & 0x3FF;
              var b = d & 0x3FF;
              codepoint = 0x10000 + (a << 10) + b;
              i += 1;
              utf16OffsetToUtf8[utf8Offset++] = ptrHead - mappingTableStartOffset;
            } else {
              codepoint = 0xFFFD;
            }
          }
        }

        var bytesRequiredToEncode = void 0;
        var offset = void 0;

        if (codepoint <= 0x7F) {
          bytesRequiredToEncode = 1;
          offset = 0;
        } else if (codepoint <= 0x07FF) {
          bytesRequiredToEncode = 2;
          offset = 0xC0;
        } else if (codepoint <= 0xFFFF) {
          bytesRequiredToEncode = 3;
          offset = 0xE0;
        } else {
          bytesRequiredToEncode = 4;
          offset = 0xF0;
        }

        if (bytesRequiredToEncode === 1) {
          u8view[ptrHead++] = codepoint;
        } else {
          if (!utf16OffsetToUtf8) {
            createOffsetTable(ptrHead);
          }

          u8view[ptrHead++] = (codepoint >> 6 * --bytesRequiredToEncode) + offset;

          while (bytesRequiredToEncode > 0) {
            var temp = codepoint >> 6 * (bytesRequiredToEncode - 1);
            u8view[ptrHead++] = 0x80 | temp & 0x3F;
            bytesRequiredToEncode -= 1;
          }
        }

        i += 1;
      }

      var utf8 = u8view.slice(0, ptrHead + 1);
      utf8[ptrHead] = 0x00;
      this._utf8Bytes = utf8;

      if (utf16OffsetToUtf8) {
        // set if UTF-16 surrogate chars or multi-byte characters found
        this._utf8Indexes = utf16OffsetToUtf8;
        this._mappingTableStartOffset = mappingTableStartOffset;
      }
    }
  }]);

  return OnigString;
}();

function findFirstInSorted(array, i) {
  var low = 0;
  var high = array.length;

  if (high === 0) {
    return 0; // no children
  }

  while (low < high) {
    var mid = Math.floor((low + high) / 2);

    if (array[mid] >= i) {
      high = mid;
    } else {
      low = mid + 1;
    }
  } // low is on the index of the first value >= i or array.length. Decrement low until we find array[low] <= i


  while (low > 0 && (low >= array.length || array[low] > i)) {
    low--;
  } // check whether we are on the second index of a utf-16 surrogate char. If so, go to the first index.


  if (low > 0 && array[low] === array[low - 1]) {
    low--;
  }

  return low;
}

exports.default = OnigString;